import { EditCriteriaData } from "../data/EditCriteria.data";


export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "channel": filterDropDownList("Channel"),
    };

    const formFields = [...EditCriteriaData.formFields,];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};